import React from 'react'

function DefaultComedy() {

console.log("ile razy?")

 const rando = (arr) => {
 return arr[Math.floor(Math.random() * arr.length)];
 }
    const ktoChlopak = ["Marek", "Krystian", "Kuba", "Wojtek", "Mateusz"];
    const ktoDziewczyna = ["Marta", "Monika", "Krysia", "Julia", "Klaudia"];
    const aktorka = [
      "Goma Rąsiorowska", 
      "Agnieszka Dygant", 
      "Katarzyna Zielińska", 
      "Katarzyna Bujakiewicz", 
      "Anna Dereszowska"];
    const aktor = [
    "Paweł Małaszyński",  
    "Maciej Stuhr", 
    "Piotr Adamczyk",  
    "Wojciech Mecwaldowski"];
    const coRobia = [
      "Razem staraja sie ocalic swieta Bozego Narodzenia. ", 
      "Sa biedni, ale udaje im sie wynajac eleganckie mieszkanie w centrum Warszawy. ",
      "Ich zycie staje na glowie, kiedy dowiaduja sie, ze stolica Australii nie jest Sydney. ",
      "Klopoty zaczynaja sie, kiedy znajduja na ulicy pieciozlotowke. ",
      "Pod wplywem impulsu postanawiaja zostac pilotami-samobojcami. "
          ];
    const czymSieZajmuje = [
      "zajmuje sie chalupniczym skladniem dlugopisow,",
      "pracuje jako namolnica parkingowa,",
      "studiuje na 5 roku EiT,", 
      "prowadzi monotonne zycie pracownika korporacji,",
      "codziennie sprawdza gazetke Biedronki, zeby zaoszczedzic 2zl na ryzu,"
          ];
    const wszystkoZmieniaSieKiedy=[
      "dowiaduja sie, ze armor nie zwieksza ich magic resista.",
      "ich adoptowany syn okazuje sie byc reptalianinem.",
      "spotykaja Czlowieko-Niedzwiedzio-Swinie.", 
      "zdaja sobie sprawe, ze dobry salceson jest wart 20zl.",
      "spotykaja wojownika z przyszlosci."
          ];
    const spotkanieChlopak = [
      "az ktoregos dnia spotyka dziewczyne imieniem",
      "kiedy pewnego dnia wpada mu w oko",
      "az na jego drodze pojawia sie",
      "ale jego zycie zmienia sie, kiedy pierwszy raz widzi, jak obok niego przechodzi",
      "by ktoregos dnia po pijaku potracic kobiete imieniem"
          ];
    const spotkanieDziewczyna = [
      "az ktoregos dnia spotyka chlopaka imieniem", 
      "gdy pewnego dnia niespodziewanie wpada jej w oko",
       "az na jej drodze pojawia sie",
       "ale jej zycie zmienia sie, kiedy pierwszy raz widzi, jak przechodzi obok niej",
       "by ktoregos dnia potykac sie o wystajacy kawalek chodnikowej plyty. Przed upadkiem ratuje ja"
          ];
    const zwrotAkcji =[
      "Ale czy fizyka kwantowa ma realny wplyw na ich zycie?",
      "Ale czy ich kot zostanie astronauta?",
      "Ale co stanie sie, kiedy zjedza nietoperza?",
      "Ale czy warto bylo kochac tak, az do bolu?",
      "Ale czy zdobeda swiat uzywajac DOTYKU MOTYLA?!"
          ];
    return (
        <div className="tekst">
    {rando(ktoChlopak)} ({rando(aktor)}) {rando(czymSieZajmuje)} 
    {rando(spotkanieChlopak)} {rando(ktoDziewczyna)} ({rando(aktorka)}) {rando(coRobia)} 
    Wszystko zmienia sie kiedy {rando(wszystkoZmieniaSieKiedy)} {rando(zwrotAkcji)}`
        </div>
    )
}

export default DefaultComedy


// const getDefaultComedy = () => {
    
  
//     return `${rando(ktoChlopak)} (${rando(aktor)}) ${rando(czymSieZajmuje)} 
//     ${rando(spotkanieChlopak)} ${rando(ktoDziewczyna)} (${rando(aktorka)}) ${rando(coRobia)} 
//     Wszystko zmienia sie kiedy ${rando(wszystkoZmieniaSieKiedy)}  ${rando(zwrotAkcji)}`
//   }